import { useState } from "react";
import { useHistory } from "react-router-dom";
import "./Sidebar.css";
import images from "../../utilities/images/images";

const Sidebar = () => {
  const [collapsed, setCollapsed] = useState(false);
  const history = useHistory();

  return (
    <aside className={`sidebar ${collapsed ? "collapsed" : ""}`}>
      <div
        className={`sidebar-header ${
          collapsed ? "header-collapsed" : "header-open"
        }`}
      >
        {!collapsed && (
          <button
            type="button"
            className="sidebar-dashboard-title"
            onClick={() => history.push("/user_dashboard")}
          >
            Dashboard
          </button>
        )}
        <img
          src={images.Hamburger}
          alt="menu"
          className="menu-icon"
          onClick={() => setCollapsed(!collapsed)}
        />
      </div>

      <nav className="sidebar-nav">
        <SidebarItem
          icon={images.home}
          label="Home"
          collapsed={collapsed}
          onClick={() => history.push("/user_dashboard")}
        />

        <SidebarItem
          icon={images.model_training}
          label="Practice"
          collapsed={collapsed}
          onClick={() => history.push("/practice")}
        />

        <SidebarItem
          icon={images.help_outline}
          label="Doubts"
          collapsed={collapsed}
          onClick={() => history.push("/doubts")}
        />

        <SidebarItem
          icon={images.storefront}
          label="Store"
          collapsed={collapsed}
          onClick={() => history.push("/store")}
        />

        <SidebarItem
          icon={images.person_outline}
          label="Profile"
          collapsed={collapsed}
          onClick={() => history.push("/user_edit_profile")}
        />
      </nav>
    </aside>
  );
};

const SidebarItem = ({ icon, label, active, collapsed, onClick }) => {
  return (
    <div
      className={`sidebar-item ${active ? "active" : ""}`}
      onClick={onClick}
      role="button"
      tabIndex={0}
    >
      <img src={icon} alt={label} className="sidebar-icon" />
      {!collapsed && <span className="sidebar-label">{label}</span>}
    </div>
  );
};

export default Sidebar;
